// zooHit: a module-level event bus so pads anywhere in the app can make a creature react.
import { newLiveHits, recordLiveHit } from "./director";

export const liveHits = newLiveHits();

/** Imperative live hit (pad pressed / note played live) → that creature reacts immediately. */
export function zooHit(slot: number, velocity: number): void {
  recordLiveHit(liveHits, slot, velocity, performance.now());
}
